
<template>
  <Loader v-if="loader" />
  <div class="card">
    <DataTable :value="invoices" :paginator="true" :rows="10" :filters="filters" 
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10,20,50]" responsiveLayout="scroll"
        currentPageReportTemplate="{first} a {last} di {totalRecords}">
        <template #header>
            <div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-end">
              <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText type="search" v-model="filters['global'].value" placeholder="Cerca..." />
                  </span>
            </div>
        </template>
        <template #empty>
            <div class="text-center">Nessun dato trovato.</div>
        </template>
        <Column field="numero" header="Fattura" :sortable="true"></Column>
        <Column field="type_doc" header="Tipo" :sortable="true"></Column>
        <Column field="data_emissione" header="Data emissione" :sortable="true">
          <template #body="{data}">
            {{formatDate(data.data_emissione)}}     
          </template>
        </Column>
        <Column field="data_scadenza" header="Data scadenza" :sortable="true">
          <template #body="{data}">
            {{formatDate(data.data_scadenza)}}     
          </template>
        </Column>
        <Column field="mese_fatturazione" header="Competenza" :sortable="true">
          <template #body="{data}">
            {{formatDate(data.mese_fatturazione)}}     
          </template>
        </Column>
        <Column field="imponibile" header="Imponibile" :sortable="true">
          <template #body="{data}">
            {{data.imponibile.toFixed(2)}}     
          </template>
        </Column>
        <Column field="iva" header="Iva" :sortable="true">
          <template #body="{data}">
            {{data.iva.toFixed(2)}}     
          </template>
        </Column>
        <Column field="totale_fattura" header="Totale" :sortable="true">
          <template #body="{data}">
            {{data.totale_fattura.toFixed(2)}}
          </template>
        </Column>
    </DataTable>
  </div>



</template>

<script>
import Service from '@/services/ask-pratiche/pratiche-service'
import { ref, onMounted, getCurrentInstance  } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'


export default {
    components: {
      Loader
    },
     setup() {

        const loader = ref(false)
        const filters = ref({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        });
        const self = getCurrentInstance();
        self.$eventBus = self.appContext.config.globalProperties.$eventBus
        self.$http = self.appContext.config.globalProperties.$http
        const formatDate = self.appContext.config.globalProperties.$formatDate
        const service = new Service(self.$http, self.$eventBus)
        const invoices = ref([]);


        onMounted(() => {       
          getData()               
        })
        const getData = () => {
          loader.value = true
          service.getAllFattureVendita().then((res) => {
              invoices.value = res.items
              console.log(invoices.value)    
          }).finally(() => {
              loader.value = false
          })
        }


        return { 
          invoices,
          loader, 
          service, 
          getData,
          formatDate, 
          filters, 
        }
    }
}
</script>

<style scoped>

</style>
